import CategoriesManagerApp from "./CategoriesSetupApp.vue";
import { vueAppWithPinia } from "../Common/vueApp";

export default vueAppWithPinia(CategoriesManagerApp);
